var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value > 0 && _vm.value < 100)?_c('Wrapper',[_vm._v(_vm._s(_vm.value))]):_c('Wrapper',[_vm._v("+99")])
}
var staticRenderFns = []

export { render, staticRenderFns }